import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ds-pagination',
  standalone: false,
  template: `
    <footer class="ds-pagination">
      <div>
        Showing <span class="fw-semibold text-dark">{{ start }}</span> to {{ end }} of
        <span class="fw-semibold text-dark">{{ total }} results</span>
      </div>
      <nav [attr.aria-label]="ariaLabel">
        <ul class="pagination pagination-sm mb-0 gap-2">
          <li class="page-item" [class.disabled]="currentPage === 0">
            <button type="button" class="page-link rounded-2 border px-3" (click)="goTo(currentPage - 1)">
              Previous
            </button>
          </li>
          @for (pageNum of pages; track pageNum) {
            <li class="page-item" [class.active]="currentPage === pageNum">
              <button type="button" class="page-link rounded-2 border" (click)="goTo(pageNum)">
                {{ pageNum + 1 }}
              </button>
            </li>
          }
          <li class="page-item" [class.disabled]="currentPage === (totalPages - 1) || totalPages === 0">
            <button type="button" class="page-link rounded-2 border px-3" (click)="goTo(currentPage + 1)">
              Next
            </button>
          </li>
        </ul>
      </nav>
    </footer>
  `,
})
export class DsPagination {
  @Input() start = 0;
  @Input() end = 0;
  @Input() total = 0;
  @Input() currentPage = 0;
  @Input() totalPages = 0;
  @Input() pages: number[] = [];
  @Input() ariaLabel = 'Page navigation';
  @Output() pageChange = new EventEmitter<number>();

  goTo(page: number) {
    if (page < 0 || page >= this.totalPages) {
      return;
    }
    this.pageChange.emit(page);
  }
}
